import * as React from "react";
import PropTypes from "prop-types";
import { graphql, useScrollRestoration, useStaticQuery } from "gatsby";
import cn from "classnames";
import { useLocation, navigate } from "@reach/router";
import ReactPaginate from "react-paginate";
import Posts from "./posts/posts";
import PressReleases from "./posts/press-release";
import Resources from "./posts/resources";
import Cards from "./cards";
import Pagination from "./pagination";
import News from "./posts/news";
import Filters from "./filters";
import Partners from "./posts/partners";
import { useState } from "react";

function GeneralFilters({ attribs }) {
  const ulScrollRestoration = useScrollRestoration("aaa");
  const [refresh, setRefresh] = useState([]);

  const {
    "data-post-type": postType,
    "data-posts-per-page": postsPerPage,
    "data-show-dropdown": showDropDown,
    "data-term-slug": termSlug,
    "data-hide-card-imagesd": enableFullWidthCards,
    "data-hide-card-images": hideCardImages,
    "data-post-category": postCategory,
  } = attribs;
  const location = useLocation();
  const q = new URLSearchParams(location.search);
  const page = q.get("page");
  let PostComponent;
  if (postType === "post") {
    PostComponent = Posts;
  } else if (postType === "lw_press") {
    PostComponent = PressReleases;
  } else if (postType === "lw_partners") {
    PostComponent = Partners;
  } else if (postType === "resources") {
    PostComponent = Resources;
  } else if (postType === "lw_news") {
    PostComponent = News;
  } else {
    return;
  }

  return (
    <section className="general-filters" {...ulScrollRestoration}>
      <PostComponent termSlug={termSlug} category={postCategory}>
        {(allCards) => {
          return (
            <div className="wrapper">
              <div
                className={cn("form-filter", {
                  "form-filter--single": !!termSlug,
                  "form-filter--fw-cards":
                    enableFullWidthCards && !hideCardImages,
                  "form-filter--no-img-cards": hideCardImages,
                })}
                // data-module="filterSelect"
              >
                <Filters
                  postCategory={postCategory}
                  term={termSlug}
                  show={showDropDown === "yes" || postType === "resources"}
                  cards={allCards}
                  postType={postType}
                >
                  {(unpagedCards) => (
                    <Pagination items={unpagedCards}>
                      {(cards, handlePageClick, pageCount) => {
                        return (
                          <>
                            <div className="tab__featured">
                              <Cards cards={cards} />
                            </div>

                            <ReactPaginate
                              className="react-pagination"
                              breakLabel="..."
                              onPageChange={handlePageClick}
                              pageRangeDisplayed={5}
                              pageCount={pageCount}
                              previousLabel=""
                              previousClassName="page-item prev"
                              previousLinkClassName="page-link icon-chevron"
                              nextLabel=""
                              nextClassName="page-item next"
                              nextLinkClassName="page-link icon-chevron"
                              pageClassName="page-item"
                              pageLinkClassName="page-link"
                              renderOnZeroPageCount={null}
                            />
                          </>
                        );
                      }}
                    </Pagination>
                  )}
                </Filters>
              </div>
            </div>
          );
        }}
      </PostComponent>
    </section>
  );
}

export default GeneralFilters;
